<template>
  <div
    class="quest"
    :class="{
      'quest--current': quest.number === getActiveQuest.number,
      'quest--success': quest.failed === false,
      'quest--fail': quest.failed === true,
    }"
    v-tooltip="
      `
      <span>Players:</span> ${quest.playersCount}<br>
      <span>Fails:</span> ${quest.failsNeeded}
    `
    "
  >
    <div
      class="quest__fails-count"
      v-if="quest.number === getActiveQuest.number"
      :class="{
        'quest__fails-count--active': getActiveQuest.failsCount !== null,
        'quest__fails-count--no-fails': getActiveQuest.failsCount === 0,
      }"
    >
      <span class="quest__fails-count-number">{{ getActiveQuest.failsCount }}</span>
    </div>

    <div class="quest__inner">
      {{ quest.playersCount }}
    </div>

    <span class="quest__fails-required" v-if="quest.failsNeeded > 1">
      Fails req.: <span class="quest__text-big">{{ quest.failsNeeded }}</span>
    </span>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      quest: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['getActiveQuest']),
    },
  };
</script>

<style scoped lang="scss">
  .quest {
    position: relative;
    display: inline-block;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    text-align: center;
    background: url(../../assets/img/game/shadow-circle.png) center no-repeat;
    background-size: contain;
    color: #ffffff;

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background: center no-repeat;
      background-size: contain;
      //
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //
      transition: opacity 400ms;
      opacity: 0;
    }

    &--current {
    }

    &--success::after {
      background-image: url(../../assets/img/game/quest-success.png);
      opacity: 1;
    }

    &--fail::after {
      background-image: url(../../assets/img/game/quest-fail.png);
      opacity: 1;
    }

    &__inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 28px;
    }

    &__fails-count {
      text-align: center;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      background-color: $red;
      color: #ffffff;
      //
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: z('above-default');
      //
      opacity: 0;
      transition: opacity 400ms;

      &--active {
        opacity: 1;
      }

      &--no-fails {
        background-color: $green;
      }
    }

    &__fails-count-number {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &__fails-required {
      display: block;
      width: 100%;
      font-size: 12px;
      white-space: nowrap;
      //
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 140%);
    }

    &__text-big {
      font-size: 16px;
      vertical-align: middle;
    }
  }
</style>
